var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "submit-button",
      attrs: {
        round: "",
        color: _vm.color,
        disabled: _vm.coDisabled,
        loading: _vm.loading
      },
      nativeOn: {
        click: function($event) {
          return _vm.handleRecord($event)
        }
      }
    },
    [
      _vm.icon
        ? _c(
            "v-icon",
            { staticClass: "mr-1", attrs: { color: _vm.iconColor, small: "" } },
            [_vm._v(_vm._s(_vm.icon))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("strong", {
        directives: [
          { name: "t", rawName: "v-t", value: _vm.title, expression: "title" }
        ],
        attrs: { color: _vm.textColor }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-351ea333", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351ea333","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/modal-record-button/template.html
// module id = null
// module chunks = 